export const allCommissionCategories = {
  NUM_BOOKINGS: 'NUM_BOOKINGS',
  TENANCY_LENGTH: 'TENANCY_LENGTH',
  REBOOKERS_COMMISSION: 'REBOOKERS_COMMISSION',
  FLAT_FEE: 'FLAT_FEE',
};

export const defaultField = [
  'category',
  'name',
  'bonus',
  'type',
  'value',
  'effectiveFrom',
  'effectiveTo',
  'checkInDateFrom',
  'checkInDateTo',
];

export const numBookings = [
  'convertedCalculationValue',
  'capType',
  'capValue',
  'tenancyLengthFrom',
  'tenancyLengthTo',
  'tenancyUnit',
  'bookingCountFrom',
  'bookingCountTo',
  'fullyCalculatable',
  'retrospectiveCommission',
  'description',
];

export const tenancyLength = [
  'convertedCalculationValue',
  'capType',
  'capValue',
  'tenancyUnit',
  'tenancyLengthFrom',
  'tenancyLengthTo',
  'fullyCalculatable',
  'retrospectiveCommission',
  'description',
];

export const flatFee = [
  'convertedCalculationValue',
  'tenancyUnit',
  'tenancyLengthFrom',
  'tenancyLengthTo',
  'capType',
  'capValue',
  'bookingCountFrom',
  'bookingCountTo',
  'fullyCalculatable',
  'description',
];

export const commissionCategories = [
  'REBOOKERS_COMMISSION',
  'FLAT_FEE',
  'NUM_BOOKINGS',
  'TENANCY_LENGTH',
];

export const commissionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRE: 'EXPIRE',
};

export const commissionDetailsCategories = {
  // Number of bookings commission
  NUM_BOOKINGS: 'cms:cms.property.commission_form_modal.commission_category.select.num_bookings',
  // Tenancy length commission
  TENANCY_LENGTH:
    'cms:cms.property.commission_form_modal.commission_category.select.tenancy_length',
  // Re-booker commission
  REBOOKERS_COMMISSION:
    'cms:cms.property.commission_form_modal.commission_category.select.rebookers_commission',
  // Flat commission
  FLAT_FEE: 'cms:cms.property.commission.create.commission_type.flat_fee',
};

export const commissionLevel = {
  PROPERTY: 'PROPERTY',
  PLATFORM: 'PLATFORM',
  LANDLORD: 'LANDLORD',
};

export default allCommissionCategories;
